import { render, staticRenderFns } from "./TnyChatWindow.vue?vue&type=template&id=03937986&"
import script from "./TnyChatWindow.vue?vue&type=script&lang=ts&"
export * from "./TnyChatWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports